define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MWoodyPlantDensityDomain = void 0;
    class MWoodyPlantDensityDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MWoodyPlantDensityDomain.ClosedOrDense, value: "Closed or Dense" },
                    { key: MWoodyPlantDensityDomain.MidDense, value: "Mid-dense" },
                    { key: MWoodyPlantDensityDomain.SparseOrOpen, value: "Sparse or Open" },
                    { key: MWoodyPlantDensityDomain.VerySparse, value: "Very Sparse" },
                    { key: MWoodyPlantDensityDomain.Isolated, value: "Isolated" },
                    { key: MWoodyPlantDensityDomain.None, value: "None" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MWoodyPlantDensityDomain.ClosedOrDense] = 0;
                this.KeyIndex[MWoodyPlantDensityDomain.MidDense] = 1;
                this.KeyIndex[MWoodyPlantDensityDomain.SparseOrOpen] = 2;
                this.KeyIndex[MWoodyPlantDensityDomain.VerySparse] = 3;
                this.KeyIndex[MWoodyPlantDensityDomain.Isolated] = 4;
                this.KeyIndex[MWoodyPlantDensityDomain.None] = 5;
                this.ValueIndex = {};
                this.ValueIndex["Closed or Dense"] = 0;
                this.ValueIndex["Mid-dense"] = 1;
                this.ValueIndex["Sparse or Open"] = 2;
                this.ValueIndex["Very Sparse"] = 3;
                this.ValueIndex["Isolated"] = 4;
                this.ValueIndex["None"] = 5;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MWoodyPlantDensityDomain = MWoodyPlantDensityDomain;
    Object.defineProperty(MWoodyPlantDensityDomain, "ClosedOrDense", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(MWoodyPlantDensityDomain, "MidDense", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(MWoodyPlantDensityDomain, "SparseOrOpen", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 3
    });
    Object.defineProperty(MWoodyPlantDensityDomain, "VerySparse", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 4
    });
    Object.defineProperty(MWoodyPlantDensityDomain, "Isolated", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 5
    });
    Object.defineProperty(MWoodyPlantDensityDomain, "None", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 6
    });
    Object.defineProperty(MWoodyPlantDensityDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
